// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".delete-contact-modal .modal-body{background-color:#f8fafb;border-top:1px solid #e0e7e9;border-bottom:1px solid #e0e7e9}.delete-contact-modal .modal-body strong{font-weight:700}", ""]);
// Exports
module.exports = exports;
